import React, { FC } from 'react';
import { CommentSection } from 'react-comments-section'
import 'react-comments-section/dist/index.css';
import { useMutation } from '@apollo/client';
import { CREATE_COMMENT } from '../Apollo/graphql/Mutation/CommentMutation';
import { getUserData } from '../utils/utilsFunctions';
import { GET_SINGLE_DESIGN, GET_SINGLE_PRINTER } from '../Apollo/graphql/Query';

interface CProps {
    parent?: any
}

const Comments: FC<CProps> = ({ parent }) => {
    const user = JSON.parse(getUserData('user'));
    const allComments = parent?.comments || [];

    let data = allComments.map((single: any) => ({
        userId: single.userId,
        comId: single.comId,
        fullName: single.fullName,
        avatarUrl: single?.avatarUrl,
        text: single.text,
        replies: single.replies.map((s: any) => ({
            userId: s.userId,
            comId: s.comId,
            fullName: s.fullName,
            avatarUrl: s?.avatarUrl,
            text: s.text,
            replies: s.replies
        }))
    }));

    const [createCommentMutation, { error }] = useMutation(CREATE_COMMENT);
    if (error) {
        console.log("something happen wrong", error);
    }

    return (
      <CommentSection
        currentUser={
          user
            ? {
                currentUserId: user?._id,
                currentUserImg:
                  user?.avatarUrl ||
                  "https://threedmake.s3.ap-southeast-2.amazonaws.com/assets/icon-user.png",
                currentUserProfile: user?.avatarUrl,
                currentUserFullName: user?.firstName,
              }
            : null
        }
        logIn={{
          loginLink: "https://3dprintit.net/signin",
          signupLink: "https://3dprintit.net/register",
        }}
        commentData={data}
        onSubmitAction={
          (data: {
            userId: string;
            comId: string;
            avatarUrl: string;
            userProfile?: string;
            fullName: string;
            text: string;
            replies: any;
            commentId: string;
          }) =>
            createCommentMutation({
              variables: {
                input: {
                  resourceId: parent._id,
                  resourceType:
                    parent.__typename === "Design" ? "design" : "printer",
                  // parentId: data.replies?.comId,
                  comment: data.text,
                },
              },
              refetchQueries: [
                parent.__typename === "Design"
                  ? {
                      query: GET_SINGLE_DESIGN,
                      variables: {
                        designId: parent._id,
                      },
                    }
                  : {
                      query: GET_SINGLE_PRINTER,
                      variables: {
                        printerId: parent._id,
                      },
                    },
              ],
            })
          // console.log("posted data",data)
        }
        onReplyAction={(data: {
          userId: string;
          parentOfRepliedCommentId: string;
          repliedToCommentId: string;
          avatarUrl: string;
          userProfile?: string;
          fullName: string;
          text: string;
        }) =>
          createCommentMutation({
            variables: {
              input: {
                resourceId: parent._id,
                resourceType:
                  parent.__typename === "Design" ? "design" : "printer",
                parentId: data.repliedToCommentId,
                comment: data.text,
              },
            },
            refetchQueries: [
              parent.__typename === "Design"
                ? {
                    query: GET_SINGLE_DESIGN,
                    variables: {
                      designId: parent._id,
                    },
                  }
                : {
                    query: GET_SINGLE_PRINTER,
                    variables: {
                      printerId: parent._id,
                    },
                  },
            ],
          })
        }
        currentData={(data: any) => {
          // console.log('curent data', data)
        }}
      />
    );
}

export default Comments;